import {DirectionalLight,AmbientLight} from "three";

const ambientLight = new AmbientLight( 0x999999, 1 )

const dirLight = new DirectionalLight(0xffffff, 0.5);
dirLight.castShadow = true;
dirLight.position.set(-200, 1000, 800);
dirLight.shadow.camera.left = -800;
dirLight.shadow.camera.right = 800;
dirLight.shadow.camera.top = 800;
dirLight.shadow.camera.bottom = -800;
dirLight.shadow.camera.near = 100;
dirLight.shadow.camera.far = 1800;

export {dirLight, ambientLight}